export enum WebhookTypes {
  CONVERSION_WEB = 'ConversionWeb',
  CONVERSION_INBOUND_CALL = 'ConversionInboundCall',
  OPPORTUNITY = 'Opportunity',
  REVENUE = 'Revenue'
}

export const getWebhookTypeFriendlyName = (
  webhookType: WebhookTypes
): string => {
  switch (webhookType) {
    case WebhookTypes.CONVERSION_WEB:
      return 'Forms';
    case WebhookTypes.CONVERSION_INBOUND_CALL:
      return 'Calls';
    default:
      return webhookType;
  }
};
